import { Fault } from '@dreryk/command-query-ws-api';
import { HealthcareFacilityPart, ServiceProvidingLocation } from '@dreryk/egabinet-healthcare-provider-frontend-api';

import { OrderingMap } from '@dreryk/command-query-ws-client';

import { useGetCurrentHealthcareProviderType } from '~libs.shared.account';

import { HealthcareProviderLocation } from './healthcareProviderLocation.types';
import { useServiceProvidingLocationForCurrentPracticeCqrsSearch } from './useServiceProvidingLocationForCurrentPracticeCqrsSearch';
import { useHealthcareFacilityPartForCurrentOrganizationCqrsSearch } from './useHealthcareFacilityPartForCurrentOrganizationCqrsSearch';
import { toHealthcareProviderLocation } from './healthcareProviderLocation.utils';

type OrderingMapVisitor = {
   forPractice?: () => OrderingMap<ServiceProvidingLocation>;
   forOrganization?: () => OrderingMap<HealthcareFacilityPart>;
};

type UseGetHealthcareProviderLocationsOutput = {
   locations: HealthcareProviderLocation[] | undefined;
   loading: boolean;
   error: Fault | Error | null;
};

type UseGetHealthcareProviderLocationsOptions = {
   orderingMapVisitor?: OrderingMapVisitor;
};

export const useGetHealthcareProviderLocations = (
   options?: UseGetHealthcareProviderLocationsOptions
): UseGetHealthcareProviderLocationsOutput => {
   const healthcareProviderType = useGetCurrentHealthcareProviderType();

   const {
      data: serviceProvidingLocations,
      loading: serviceProvidingLocationsLoading,
      error: serviceProvidingLocationsError,
   } = useServiceProvidingLocationForCurrentPracticeCqrsSearch({
      enabled: healthcareProviderType === 'HEALTHCARE_PRACTICE',
      orderingMap: options?.orderingMapVisitor?.forPractice?.(),
   });

   const {
      data: healthcareFacilityPart,
      loading: healthcareFacilityPartLoading,
      error: healthcareFacilityPartError,
   } = useHealthcareFacilityPartForCurrentOrganizationCqrsSearch({
      enabled: healthcareProviderType === 'HEALTHCARE_ORGANIZATION',
      orderingMap: options?.orderingMapVisitor?.forOrganization?.(),
   });

   return {
      locations: (serviceProvidingLocations || healthcareFacilityPart)?.map(toHealthcareProviderLocation),
      loading: serviceProvidingLocationsLoading || healthcareFacilityPartLoading,
      error: serviceProvidingLocationsError || healthcareFacilityPartError,
   };
};
